export const USERS = ['Mike', 'Matt', 'Peter', 'Sean', 'Sarah', 'Kyle', 'Jason', 'Lara'];
export const getUserName = (id: number) => USERS[id - 1];
